import React from "react";
import { useEffect } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Modal from 'react-bootstrap/Modal';
import { TiHome } from "react-icons/ti";
import { RiNewsFill } from "react-icons/ri";
import { IoMdChatboxes } from "react-icons/io";
import { FaBell } from "react-icons/fa";
import { BiSolidCalendarEvent } from "react-icons/bi";
import { TbClubsFilled } from "react-icons/tb";
import { FaUserAlt } from "react-icons/fa";
import { IoMdHelpBuoy } from "react-icons/io";
import { RiSettingsFill } from "react-icons/ri";
import { IoMdArrowForward } from "react-icons/io";
import logo from "../assets/images/logo-fanfub-big.png";
import ProfileCardImage from "../assets/images/profile-card.svg";
import goolge from "../assets/images/google.svg";
import apple from "../assets/images/apple.svg";
import { useAuth } from "../../src/context/AuthContext";
import { Row, Col } from "react-bootstrap";
import { notifications } from '../components/notifications';

const Sidebar = ({ isCollapsed, setIsCollapsed }) => {
  const location = useLocation();
  const [modalShow, setModalShow] = React.useState(false);
  const [unreadCount, setUnreadCount] = React.useState(0);
  const navigate = useNavigate(); // Use useNavigate instead of useHistory
  const { isAuthenticated } = useAuth(); // Get Auth State
  const handleSignInClick = () => {
    // Navigate to the SignIn component
    navigate('/signin'); // Updated navigation logic
  };

  const handleSignUpClick = () => {
    // Navigate to the SignIn component
    navigate('/signup'); // Updated navigation logic
  };

  // ✅ Ensure menu is collapsed when opening on mobile
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 575) {
        setIsCollapsed(false); // Close menu when resizing to mobile
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [setIsCollapsed]);

  // ✅ Close menu when navigating to a different route
  useEffect(() => {
    setIsCollapsed(false);
  }, [location.pathname, setIsCollapsed]);

  useEffect(() => {
    const readNotifications = JSON.parse(localStorage.getItem('readNotifications') || '[]');
    const allNotificationIds = notifications.map(notification => notification.id);
    const unread = allNotificationIds.filter(id => !readNotifications.includes(id));
    setUnreadCount(unread.length);
  }, [location.pathname]);

  function AuthModal(props) {
    return (
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="auth-modal"
      >
        <div className="auth-modal-body">
          <div className="auth-modal-logo">
            <img src={logo} alt="Company logo" className="image-full" />
          </div>
          <div className="auth-modal-content">
            <h1>Join the Ultimate Fanhub Hub</h1>
            <p>Share, Discuss, and Connect with Like-Minded People!</p>
          </div>
          <div className="d-grid gap-3 social-login">
            <Button className="google-btn">
              <img src={goolge} alt="Google" className="icon" /> Sign Up with Google
            </Button>
            <Button className="apple-btn">
              <img src={apple} alt="Apple" className="icon" /> Sign Up with Apple
            </Button>
            <p>By creating an account, you agree to our <Link to={`/help`}>Terms of Use</Link> and <Link to={`/help`}>Privacy Policy</Link></p>
          </div>
          <div className="or-devider">
            <span>OR</span>
          </div>
          <div className="d-grid email-login">
            <Button variant="primary" size="lg" className="sign-up" onClick={handleSignUpClick}>
              Sign Up
            </Button>
            <p>Already have an account?</p>
            <Button variant="outline-primary" size="lg" className="sign-in" onClick={handleSignInClick}>
              Sign In
            </Button>
          </div>
        </div>
        <Modal.Footer className="auth-modal-footer">
          <Button onClick={props.onHide} variant="link">I Would Like to Browse Only <IoMdArrowForward /></Button>
        </Modal.Footer>
      </Modal>
    );
  }

  // Define menu items (conditionally include "My Profile" & "Account" only if authenticated)
  const menuItems = [
    { label: "Home", icon: TiHome, path: "/" },
    { label: "News", icon: RiNewsFill, path: "/news" },
    ...(isAuthenticated
      ? [
        { label: "Messages", icon: IoMdChatboxes, path: "/messages" },
        { label: "Notifications", icon: FaBell, path: "/notifications", count: unreadCount, },
      ]
      : []), // Only add these if logged in
    { label: "Events", icon: BiSolidCalendarEvent, path: "/events" },
    { label: "Clubs", icon: TbClubsFilled, path: "/clubs" },
    ...(isAuthenticated
      ? [
        { label: "My Profile", icon: FaUserAlt, path: "/profile" },
        { label: "Account", icon: RiSettingsFill, path: "/account" },
      ]
      : []), // Only add these if logged in
    { label: "Help", icon: IoMdHelpBuoy, path: "/help" },
  ];

  return (

    <div className={`left-menu ${isCollapsed ? "collapsed" : ""}`}>


      <div className="d-grid gap-2">
        {isAuthenticated ? (
          // ✅ Show Profile Card if Logged In
          <div className="profile-card">
            <div>
              {/* Profile Image & Name Section */}
              <div className="profile-header text-center">
                <div className="p-card-image">
                  <img src={ProfileCardImage} // Replace with actual user image
                    alt="Profile"
                    className="profile-img"
                  />
                </div>
                <div className="p-card-content">
                  <h4 className="profile-name">Rose Winslet</h4>
                  <p className="profile-handle">@rosewinslet</p>
                </div>
              </div>

              {/* Follower, Following, Posts Section */}
              <Row className="stats-section text-center gx-3">
                <Col className="stat-box">
                  <h5>1.2k</h5>
                  <p>Followers</p>
                </Col>
                <Col className="stat-box">
                  <h5>56</h5>
                  <p>Following</p>
                </Col>
                <Col className="stat-box">
                  <h5>264</h5>
                  <p>Posts</p>
                </Col>
              </Row>
            </div>
          </div>
        ) : (
          // ❌ Show Sign In / Register Button if NOT Logged In
          <div className="d-grid gap-2">
            <Button size="lg" className="br-10" onClick={() => setModalShow(true)}>
              Sign in / Register
            </Button>
            <AuthModal show={modalShow} onHide={() => setModalShow(false)} />
          </div>
        )}
      </div>

      {/* Menu List */}

      <ul className="mt-4 left-menu-panel">
        {menuItems.map((item, index) => {
          const isActive =
            item.path === "/"
              ? location.pathname === "/"
              : location.pathname.startsWith(item.path);

          return (
            <li
              key={index}
              className={`flex items-center rounded-lg cursor-pointer ${isActive ? "active-menu bg-pink-100" : "hover:bg-pink-50"
                }`}
            >
              {/* <Link
                to={item.path}
                className="flex items-center rounded-lg"
                onClick={() => {
                  setIsCollapsed(true); // Collapse menu after clicking
                }}
              >
                <item.icon style={{ width: "28px", height: "22px" }} className="text-pink-500" />
                <span className="text-pink-500 font-medium ml-2">{item.label}</span>
              </Link> */}

              <Link
                to={item.path}
                className="flex items-center justify-between rounded-lg w-full"
                onClick={() => {
                  setIsCollapsed(true);
                }}
              >
                <div className="flex items-center">
                  <item.icon style={{ width: "28px", height: "22px" }} className="text-pink-500" />
                  <span className="text-pink-500 font-medium ml-2">{item.label}</span>
                </div>

                {/* Add count display for Notifications */}
                {item.label === "Notifications" && item.count > 0 && (
                  <span className="badge-count">{item.count}</span>
                )}
              </Link>
            </li>
          );
        })}
      </ul>

    </div>
  );
};

export default Sidebar;